import { render, staticRenderFns } from "./ScrollContent.vue?vue&type=template&id=b4918116"
import script from "./ScrollContent.vue?vue&type=script&lang=js"
export * from "./ScrollContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports